import { Link, Text } from "@salt-ds/core";
import { MessageIcon } from "@salt-ds/icons";
import {
  CONTACTUS,
  FOOTER_PRIVACY_URL,
  FOOTER_TEXT,
  FOOTER_TNC_URL,
  PRIVACY_STRING,
  TERMS_CONDITIONS,
} from "src/utils/Constants";
import { useSelector } from "react-redux";
import store from "src/store/store";
import ButtonComponent from "src/components/ButtonComponent";
import { openEmailClient } from "src/utils/UtilityFunction";

const Footer = () => {
  const secData = useSelector(
    (state: ReturnType<typeof store.getState>) => state.getSecData.value,
  );
  const contentTargetEnrollment =
    secData?.secDataDetails?.content?.contentTargetEnrollment;
  const mailtoLink = openEmailClient(contentTargetEnrollment);

  return (
    <footer className="w-full  h-20 px-6 pt-px pb-[23px] bg-white flex-col justify-start items-start gap-6 inline-flex">
      <div className="w-full h-[0px] border border-slate-400"></div>
      <div className="w-full h-8 justify-between items-center inline-flex  ">
        <div className="w-1/3 justify-start items-center  inline-flex">
          <ButtonComponent
            onClick={() => (window.location.href = mailtoLink)}
            variant="secondary"
            className="hover:text-customBlue focus:bg-buttonBlue focus:text-customBlue font-['Amplitude'] text-[14px] text-customBlue float-end normal-case hover:bg-buttonBlue rounded"
          >
            <MessageIcon className="mr-[10px]" />
            {CONTACTUS}
          </ButtonComponent>
        </div>
        <div className="w-1/3 h-4 justify-center items-center gap-4 inline-flex ">
          <Link href={`${FOOTER_PRIVACY_URL}`} target="_blank" rel="noopener">
            {PRIVACY_STRING}
          </Link>
          <Link href={`${FOOTER_TNC_URL}`} target="_blank" rel="noopener">
            {TERMS_CONDITIONS}
          </Link>
        </div>
        <div className="w-1/3 h-4 justify-end items-end gap-4 inline-flex ">
          <Text>
            {" "}
            ©{new Date().getFullYear()} {FOOTER_TEXT}
          </Text>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
